/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MatchAuditResponse = {
    properties: {
        id: {
            type: 'string',
            isRequired: true,
        },
        createdAt: {
            type: 'string',
            format: 'date-time',
        },
        createdById: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        event: {
            type: 'array',
            contains: {
                type: 'ParentEventEntryResponse',
            },
        },
        lineup: {
            type: 'array',
            contains: {
                type: 'LineupEntryResponse',
            },
        },
        time: {
            type: 'array',
            contains: {
                type: 'TimeEntryResponse',
            },
        },
        createdBy: {
            type: 'UserSmall',
            isRequired: true,
        },
    },
} as const;
